<template>
    <div class="custom-suggestion-input-container">
        <div class="custom-suggestion-input">
            <vue-autosuggest :input-props="inputProps" :suggestions="suggestions" @selected="suggestionSelected" @input="inputChanged" :value="value">
            </vue-autosuggest>
        </div>
    </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'

export default {
    components: {
        VueAutosuggest,
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        suggestions: {
            type: Array,
            default: () => {
                return []
            },
        },
        value: {
            type: String,
        },
    },
    watch: {
        placeholder() {
            this.setProps()
        },
        // value() {
        //     this.$emit('input', this.value)
        // }
    },
    data() {
        return {
            inputProps: {
                id: 'autosuggest__input',
                placeholder: '',
            },
        }
    },
    methods: {
        // setup
        setProps() {
            this.inputProps.placeholder = this.placeholder
        },
        // input
        suggestionSelected(suggestionItem) {
            if (suggestionItem != null) {
                this.$emit('input', suggestionItem.item)
            }
        },
        inputChanged(value) {
            this.$emit('input', value)
        },
    },
    mounted() {
        this.setProps()
    },
}
</script>

<style lang="scss">
#autosuggest {
    height: 100%;
    div {
        height: 100%;
    }

    .autosuggest__results-container {
        .autosuggest__results {
            ul {
                position: relative;
                z-index: 1;
                background: var(--primary);
                padding: 0px;
                margin: 0px;
                list-style: none;
                max-height: 150px;
                overflow-y: scroll;
                .autosuggest__results-item {
                    cursor: pointer;
                    color: white;
                    padding: 4px 8px;
                }
            }
        }
    }
}

.custom-suggestion-input-container {
    background-color: inherit;
    .custom-suggestion-input {
        height: 40px;
        position: relative;
        background-color: inherit;

        input {
            background-color: inherit;
            border: 1px solid var(--secondary-3);
            border-radius: 4px;
            margin: 0 !important;
            padding-left: 16px;
            padding-right: 16px;
            color: white;
            caret-color: var(--secondary);
            transition: border-color color 0.3s;
            height: 100%;
            width: 100%;
            outline: 0px;

            &::placeholder {
                color: var(--secondary-1);
                opacity: 1;
            }

            &:focus {
                color: var(--light);
                transition: border-color color 0.3s;
                box-shadow: none;
                outline: none;

                &.light {
                    border-color: var(--light);

                    & + label {
                        color: var(--light);
                        transition: color 0.3s;
                    }
                }

                &.blue,
                &.dark {
                    border-color: var(--secondary);

                    & + label {
                        color: var(--secondary);
                        transition: color 0.3s;
                    }
                }
            }
        }
    }
}
</style>
